module.exports = __webpack_public_path__ + "img/barriles.f81d52ac.gif";